<script lang="ts" setup>
const { $t } = useNuxtApp()
</script>
<template>
  <button
    class="d-block position-absolute top-50 end-0 translate-middle-y me-4 p-0 border-0 bg-transparent z-index-5"
    type="button"
    :aria-label="$t('Vymazať dátum')"
  >
    <img
      src="~/assets/icons/close.svg"
      width="19"
      height="19"
      alt=""
      loading="lazy"
      decoding="async"
      class="d-block"
    >
  </button>
</template>
